import { Analytics } from '@vercel/analytics/react';
import SmoothScroll from './effects/SmoothScroll';
import ScrollProgress from './effects/ScrollProgress';
import PageBackground from './effects/PageBackground';
import SideRail from './layout/SideRail';
import TopNav from './layout/TopNav';
import HeroSection from './sections/HeroSection';
import ProjectsSection from './sections/ProjectsSection';
import AboutSection from './sections/AboutSection';
import ContactSection from './sections/ContactSection';
import './styles/main.scss';

function App() {
  return (
    <SmoothScroll>
      <div className="app-shell app-shell--studio">
        <PageBackground />
        <ScrollProgress />
        <a href="#hero" className="skip-link">Skip to main content</a>
        <SideRail />
        <TopNav />
        <main className="main-content">
          <HeroSection />
          <ProjectsSection />
          <AboutSection />
          <ContactSection />
        </main>
        <Analytics />
      </div>
    </SmoothScroll>
  );
}

export default App;
